import React, { useState } from "react";
import { Avatar, List, Space, Typography, Badge, Button, Tooltip } from "antd";
import { MessageOutlined, SmileOutlined } from "@ant-design/icons";
import CommentDrawer from "./CommentDrawer";
import styled from "styled-components";
import { getUserList } from "redux/selectors";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";


const Drawer = styled.div`
  .ant-badge-count,
  .ant-badge-dot,
  .ant-badge .ant-scroll-number-custom-component {
    position: absolute;
    top: -5px;
    left: -22px;
    transform: translate(50%, -50%);
    transform-origin: 100% 0%;
  }
  .ant-list-item-meta {
    display: flex;
    flex: 1 1;
    align-items: center;
    max-width: 100%;
  }
  .ant-spin-container {
    max-height: 200px;
  }
  .ant-list-item-action {
    flex: 0 0 auto;
    margin-right: 20px;
    padding: 0;
    font-size: 0;
    list-style: none;
  }
`;

const { Text } = Typography;

const emojis = ["😊", "😍", "🎉", "😄", "❤️"];

const EmojiTooltip = ({ onSelect }) => (
  <Space size={8}>
    {emojis.map((emoji) => (
      <span
        key={emoji}
        style={{
          fontSize: 18,
          cursor: "pointer",
          lineHeight: 1,
        }}
        onClick={() => onSelect(emoji)}
      >
        {emoji}
      </span>
    ))}
  </Space>
);

const birthdayData = [
  {
    id: 1,
    name: "John Abraham",
    role: "Senior Designer",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    reactions: [
      { emoji: "😄", count: 17 },
      { emoji: "🎂", count: 5 },
    ],
  },
  {
    id: 2,
    name: "Elisa William",
    role: "General Manager",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    reactions: [
      { emoji: "❤️", count: 24 },
      { emoji: "😊", count: 8 },
    ],
  },
  {
    id: 3,
    name: "Anna Dev",
    role: "Project Lead",
    avatar: "https://randomuser.me/api/portraits/women/65.jpg",
    reactions: [],
  },
];


const BirthdaySpotLight = ({ userList }) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  console.log(userList, "userListin birthday spotlight");

  const getTodayBirthdays = (userList = []) => {
    const today = new Date();

    const todayDate = today.getUTCDate();
    const todayMonth = today.getUTCMonth(); // 0-based

    return userList.filter((user) => {
      if (!user.dateofbirth) return false;

      const dob = new Date(user.dateofbirth);

      return (
        dob.getUTCDate() === todayDate &&
        dob.getUTCMonth() === todayMonth
      );
    });
  };


  const todayBirthdayUsers = getTodayBirthdays(userList);
  console.log(userList, "userList")

  console.log(todayBirthdayUsers, "todayBirthdayUsers");

  const openComments = (user) => {
    setSelectedUser(user);
    setOpenDrawer(true);
  };

  return (
    <Drawer>
      <List
        header={<Text strong>Today’s Birthday Spotlight</Text>}
        dataSource={todayBirthdayUsers}
        itemLayout="horizontal"
        style={{ maxHeight: 350, overflowY: "auto" }}
        renderItem={(item) => (
          <List.Item
            // actions={[
            //   <Tooltip
            //     key="emoji"
            //     trigger="click"
            //     placement="top"
            //     title={
            //       <EmojiTooltip
            //         onSelect={(emoji) => {
            //           console.log("Selected emoji:", emoji, item.name);
            //           // 👉 You can update reaction count here
            //         }}
            //       />
            //     }
            //   >
            //     <SmileOutlined style={{ fontSize: 18, cursor: "pointer" }} />
            //   </Tooltip>,

            //   <Badge
            //     key="comment"
            //     count={0}
            //   >
            //     <MessageOutlined
            //       style={{ fontSize: 18, cursor: "pointer" }}
            //       onClick={() => openComments(item)}
            //     />
            //   </Badge>,
            // ]}
          >
            <List.Item.Meta
              avatar={<Avatar src={item.profileurl} size={48}>
                {!item.profileurl && item.fullname?.charAt(0).toUpperCase()}
              </Avatar>
              }
              title={<Text strong>{item.fullname}</Text>}
              description={
                <Space direction="vertical" size={4}>
                  <Text type="secondary">{item.rolename[0]}</Text>

                  {Array.isArray(item.reactions) && item.reactions.length > 0 && (
                    <Space wrap>
                      {item.reactions.map((r, i) => (
                        <Button key={i} size="small">
                          {r.emoji} {r.count}
                        </Button>
                      ))}
                    </Space>
                  )}

                </Space>
              }
            />
          </List.Item>
        )}
      />

      <CommentDrawer
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        user={selectedUser}
      />
    </Drawer>
  );
}
const mapStateToProps = (state) => ({
  userList: getUserList(state),

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {

    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(BirthdaySpotLight);


